import { TippyProps } from '@tippyjs/react'

export type Modifier = ArrayElement<TippyProps['popperOptions']['modifiers']>

export const appearInViewModifier: Modifier = {
  name: 'preventOverflow',
  enabled: true,
  options: {
    mainAxis: true,
    altAxis: true,
  },
}

export const appearInViewPopperOptions: TippyProps['popperOptions'] = {
  modifiers: [appearInViewModifier],
}
